export default __webpack_public_path__ + "static/media/l16.f8a6827d.jpg";